export const Cookies = Object.freeze({
  TOKEN: 'token',
  USER: 'user',
  SWITCH_USER: 'switch_user_id'
})
